import React, { useEffect, useState } from 'react'

import CustomFieldRender from '../../../../../../components/CustomFieldRender'
import { useGetFieldOptionRelationshipsQuery } from '../../services/field'

export function CustomField({ field, value, setValues, errors, isReadOnly, groupFields }) {
  const [mainOption, setMainOption] = useState(null)

  const { data: relationships } = useGetFieldOptionRelationshipsQuery(
    { mainOptionId: mainOption?.optionId },
    { skip: !mainOption?.optionId }
  )

  useEffect(
    function setRelationships() {
      if (relationships && mainOption) {
        let values = { [field.internalFieldName]: mainOption.value }

        relationships.forEach(function ({ formFieldId, relatedOptionId }) {
          const { internalFieldName, fieldProperties } = groupFields.find(({ id }) => id === formFieldId)
          const relatedOptionValue = fieldProperties.options.find(({ id }) => id === relatedOptionId).value
          values[internalFieldName] = relatedOptionValue
        })

        setValues(values)
        setMainOption(null)
      }
    },
    [relationships]
  )

  async function onChangeValue(fieldName, value) {
    let values = { [fieldName]: value }

    if (field.hasRelationships && value) {
      const optionId = field.fieldProperties.options.find((option) => option.value === value).id
      setMainOption({ optionId, value })
    } else {
      setValues(values)
    }
  }

  return (
    <CustomFieldRender
      enable={isReadOnly}
      disabled={isReadOnly}
      value={{ [field.internalFieldName]: value }}
      field={field}
      errors={errors}
      setFieldValue={onChangeValue}
    />
  )
}
